import { graphql, readInlineData } from 'relay-runtime';
import { getGuestUserId } from '../../helpers/checkoutGuestUserToken';
import { paymentMethodIsPermissible_paymentMethod$key } from './__generated__/paymentMethodIsPermissible_paymentMethod.graphql';

export function paymentMethodIsPermissible(
    walletPaymentMethodRef: paymentMethodIsPermissible_paymentMethod$key | null,
    shippingAddressId: string
): boolean {
    if (getGuestUserId()) {
        // cards are not stored to wallet on guest checkout, no need for verification
        return true;
    }

    const walletPaymentMethod = readInlineData(
        graphql`
            fragment paymentMethodIsPermissible_paymentMethod on WalletPaymentMethod @inline {
                shippingAddresses {
                    serviceId
                }
            }
        `,
        walletPaymentMethodRef
    );

    return (walletPaymentMethod?.shippingAddresses || []).some(
        shippingAddress => shippingAddress && shippingAddress.serviceId === shippingAddressId
    );
}
